const getCanUseLocalStorage = (): boolean => {
  try {
    localStorage.setItem('localStorageTest', 'true');
    localStorage.removeItem('localStorageTest');
    return true;
  } catch {
    return false;
  }
};

export const canUseLocalStorage = getCanUseLocalStorage();
